import { render } from "./AirportsList.vue?vue&type=template&id=25312900&scoped=true"
import script from "./AirportsList.vue?vue&type=script&lang=js"
export * from "./AirportsList.vue?vue&type=script&lang=js"

import "./AirportsList.vue?vue&type=style&index=0&id=25312900&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25312900"]])

export default __exports__